export function initPaypalButtons() {
    //Visible paypal buttons
    const elem = document.querySelector('.wpedon_paypalbuttonimage');
    if (elem !== null) {
        elem.src = '';
        elem.alt = 'Donate';
        elem.classList.add('button', 'button--primary');
        elem.style.opacity = 1;
    }
    //Headers button submit the hidden form in the footer
    var elems = document.querySelectorAll('header .js-donate a, .dropdown__container .js-donate a');
    var form = document.querySelector('#paypal-donation-form form');
    for (var i = elems.length - 1; i >= 0; i--) {
        elems[i].addEventListener('click', function () {
            form.submit();
        });
    }
}
